<template>
  <div class="finance-group-dashboard" v-loading="loading">
    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <el-radio-group class="mb16" v-model="statCycle" size="small" @input="handleStatCycleChange">
      <el-radio-button :label="1">昨日</el-radio-button>
      <el-radio-button :label="2">本周</el-radio-button>
      <el-radio-button :label="3">本月</el-radio-button>
    </el-radio-group>

    <el-row class="mb16">
      <el-col :span="24">
         <!-- 应收金额 -->
        <HorizontalCardStyle1
          :title="receivableData.title"
          :dataDesc="receivableData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="receivableData.primaryDataList"
          :secondaryDataList="receivableData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16">
      <el-col :span="24">
        <!-- 应付金额 -->
        <HorizontalCardStyle1
          :title="paymentData.title"
          :dataDesc="paymentData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="paymentData.primaryDataList"
          :secondaryDataList="paymentData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 车辆成本 -->
        <HorizontalCardStyle2
          :title="vehicleData.title"
          :dataDesc="vehicleData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="vehicleData.primaryDataList"
          :secondaryDataList="vehicleData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 营销成本 -->
        <HorizontalCardStyle2
          :title="marketingData.title"
          :dataDesc="marketingData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="marketingData.primaryDataList"
          :secondaryDataList="marketingData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16">
      <el-col :span="24">
        <!-- 欠款 -->
        <HorizontalCardStyle1
          :title="debtData.title"
          :dataDesc="debtData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="debtData.primaryDataList"
          :secondaryDataList="debtData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <div class="module-title">数据分析</div>

    <el-row class="mb16">
      <el-col :span="24">
        <FiltersBox
          :filterList="localFilter.filterList"
          :model.sync="localFilter.model"
          @change="handleLocalFiltersChange"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 收款金额（柱状图） -->
        <BarChartCard
          class="chart"
          :title="receivableChartData.title"
          :tooltip="receivableChartData.tooltip"
          :dataDesc="receivableChartData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :xAxis="receivableChartData.xAxis"
          :yAxis="receivableChartData.yAxis"
          :legendData="receivableChartData.legendData"
          :seriesData="receivableChartData.seriesData"
          :unit="receivableChartData.unit"
        />
      </el-col>
      <el-col :span="12">
        <!-- 付款金额（柱状图） -->
        <BarChartCard
          class="chart"
          :title="paymentChartData.title"
          :tooltip="paymentChartData.tooltip"
          :dataDesc="paymentChartData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :xAxis="paymentChartData.xAxis"
          :yAxis="paymentChartData.yAxis"
          :legendData="paymentChartData.legendData"
          :seriesData="paymentChartData.seriesData"
          :unit="paymentChartData.unit"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 欠款金额（折线图） -->
        <LineChartCard
          class="chart"
          :title="debtChartData.title"
          :tooltip="debtChartData.tooltip"
          :dataDesc="debtChartData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :xAxis="debtChartData.xAxis"
          :yAxis="debtChartData.yAxis"
          :legendData="debtChartData.legendData"
          :seriesData="debtChartData.seriesData"
          :unit="debtChartData.unit"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1'
import HorizontalCardStyle2 from '@/bizComponents/Dashboard/cards/horizontalCard/style2'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard/index.vue'
import BarChartCard from '@/bizComponents/Dashboard/cards/barChartCard/index.vue'
// eslint-disable-next-line import/no-cycle
import {
  getFinanceReceivable,
  getFinanceReceivableChart,
  getFinancePayment,
  getFinancePaymentChart,
  getFinanceDebt,
  getFinanceDebtChart,
  getFinanceCost,
} from '@/api/domain/finance'
import { convertNumber } from '@/utils/'
import { yesterday, thisWeekT_1, thisMonthT_1 } from '../../config'

export default {
  components: {
    FiltersBox,
    HorizontalCardStyle1,
    HorizontalCardStyle2,
    LineChartCard,
    BarChartCard,
  },
  provide() {
    return {
      ratioConfig: {
        showRatio: true,
      },
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
        },
      },
      // 统计周期(1:昨日 2:当周平均 3:当月平均)
      statCycle: 1,
      // 局部筛选
      localFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            pickerOptions: {
              disabledDate: (time) => {
                return time.getTime() < (Date.now() - 180 * 24 * 60 * 60 * 1000) || time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
        ],
        model: {
          // 默认最近7天
          date: [
            moment(moment(Date.now() - 24 * 60 * 60 * 1000 - (7 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(moment(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
        },
      },
      // 数据更新时间
      dataUpdateTime: '',
      // 应收金额
      receivableData: {
        title: '应收金额',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 应付金额
      paymentData: {
        title: '应付金额',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 车辆成本
      vehicleData: {
        title: '车辆成本',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 营销成本
      marketingData: {
        title: '营销成本',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 欠款
      debtData: {
        title: '欠款',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 收款金额
      receivableChartData: {
        title: '收款金额',
        tooltip: '统计周期内每日应收金额与实收金额',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}万元',
          },
        },
        legendData: ['应收金额', '实收金额'],
        seriesData: [],
        unit: '万元',
      },
      // 付款金额
      paymentChartData: {
        title: '付款金额',
        tooltip: '统计周期内每日应付金额与已付金额',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}万元',
          },
        },
        legendData: ['应付金额', '已付金额'],
        seriesData: [],
        unit: '万元',
      },
      // 欠款金额
      debtChartData: {
        title: '欠款金额',
        tooltip: '统计周期内每日欠款金额总和',
        dataDesc: 'T-1日数据',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}万元',
          },
        },
        legendData: ['个人客户', '企业客户'],
        seriesData: [],
        unit: '万元',
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      const { date } = this.localFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
        statCycle: this.statCycle,
        receiveStartDate: startDate,
        receiveEntDate: endDate,
        paymentStartDate: startDate,
        paymentEntDate: endDate,
        debtStartDate: startDate,
        debtEntDate: endDate,
      }
    },
    theOrderStart() {
      let times = thisMonthT_1
      if (this.statCycle === 1) {
        times = yesterday
      } else if (this.statCycle === 2) {
        times = thisWeekT_1
      }
      return times
    },
    // 根部门ID
    rootDeptId() {
      return this.$store.getters.userInfo.rootDeptId
    },
    // 部门路由参数
    routerDeptId() {
      const selectedDeptId = this.globalFilter.model.deptId
      return selectedDeptId === this.rootDeptId ? '' : selectedDeptId
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.update()
  },
  activated() {
    this.update()
    this.$nextTick(() => {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    })
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.updateCardData(),
        this.updateChartData(),
      ]).finally(() => {
        this.loading = false
      })
    },
    async updateCardData() {
      await Promise.all([
        this.getFinanceReceivable(),
        this.getFinancePayment(),
        this.getFinanceCost(),
        this.getFinanceDebt(),
      ])
    },
    async updateChartData() {
      await Promise.all([
        this.getFinanceReceivableChart(),
        this.getFinancePaymentChart(),
        this.getFinanceDebtChart(),
      ])
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleLocalFiltersChange() {
      this.update()
    },
    handleStatCycleChange() {
      this.update()
    },
    // 跳转财务-应收管理
    toFinanceCollectionList({ content, receivableStates, customerType, relieveState, customerInfoType }) {
      const query = {
        deptId: this.routerDeptId,
        times: JSON.stringify(this.theOrderStart),
      }
      // 收款内容，1:租金 2:押金
      if (typeof content !== 'undefined') {
        query.content = content
      }
      // 收款状态，0:未完成
      if (typeof receivableStates !== 'undefined') {
        query.receivableStates = receivableStates
      }
      // 付款方类型 1:服务商 2:客户(产品计划将客户拆分为个人客户、企业客户，但本期不做)
      if (typeof customerType !== 'undefined') {
        query.customerType = customerType
      }
      // 是否减免金额 0:否 1:是
      if (typeof relieveState !== 'undefined') {
        query.relieveState = relieveState
      }

      // 客户类型 1:个人客户 2:企业客户
      if (typeof customerInfoType !== 'undefined') {
        query.customerInfoType = customerInfoType
      }
      this.$router.push({
        path: '/finance/collection',
        query,
      })
    },
    // 跳转财务-应付管理
    toFinancePayableList({ payType, purchaseType }) {
      const query = {
        deptId: this.routerDeptId,
        times: JSON.stringify(this.theOrderStart),
      }
      // 付款内容 1:租金 12:押金退款
      if (typeof payType !== 'undefined') {
        query.payType = payType
      }
      // 采购方式 1:购买 2: 租用
      if (typeof purchaseType !== 'undefined') {
        query.purchaseType = purchaseType
      }
      this.$router.push({
        path: '/finance/payable',
        query,
      })
    },
    // 获取应收金额
    async getFinanceReceivable() {
      const res = await getFinanceReceivable(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.dataUpdateTime = data.recentUpdateTime || ''
        this.receivableData.primaryDataList = [
          {
            label: '累计应收金额',
            value: convertNumber((data.totalAmount || 0) / 10000),
            unit: '万元',
            valueTooltip: `${convertNumber(data.totalAmount || 0)}元`,
            tooltip: '历史累计应收金额总和',
            width: '266px',
            // 财务-应收管理
            clickCallback: () => this.toFinanceCollectionList({}),
          },
        ]
        this.receivableData.secondaryDataList = [
          {
            label: '新增应收金额',
            value: convertNumber(data.newAddAmount || 0),
            unit: '元',
            tooltip: '统计周期内应收金额总和',
            // 财务-应收管理 应收时间为统计周期时间
            clickCallback: () => {
              this.toFinanceCollectionList({})
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.newAddDayRadio,
                },
                {
                  name: '周同比',
                  value: data.newAddWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '应收租金',
            value: convertNumber(data.rentAmount || 0),
            unit: '元',
            tooltip: '统计周期内收款内容为“租金”的应收金额总和',
            // 财务-应收管理 收款内容为“租金”
            clickCallback: () => {
              this.toFinanceCollectionList({ content: 1 })
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.rentDayRadio,
                },
                {
                  name: '周同比',
                  value: data.rentWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '应收押金',
            value: convertNumber(data.depositAmount || 0),
            unit: '元',
            tooltip: '统计周期内收款内容为“押金”的应收金额总和',
            // 财务-应收管理 收款内容为“押金”
            clickCallback: () => {
              this.toFinanceCollectionList({ content: 2 })
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.depositDayRadio,
                },
                {
                  name: '周同比',
                  value: data.depositWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '收款完成率',
            value: ((data.collectFinishRadio || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内应收单 实际收款金额总和/应收金额总和',
            // 财务-应收管理
            clickCallback: () => {
              this.toFinanceCollectionList({})
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.collectFinishDayRadio,
                },
                {
                  name: '周同比',
                  value: data.collectFinishWeekRadio,
                },
              ]
              : [],
          },
        ]
      }
    },
    // 获取应付金额
    async getFinancePayment() {
      const res = await getFinancePayment(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.paymentData.primaryDataList = [
          {
            label: '累计应付金额',
            value: convertNumber((data.totalAmount || 0) / 10000),
            unit: '万元',
            valueTooltip: `${convertNumber(data.totalAmount || 0)}元`,
            tooltip: '历史累计应付金额总和',
            width: '266px',
            // 财务-应付管理
            clickCallback: () => this.toFinancePayableList({}),
          },
        ]
        this.paymentData.secondaryDataList = [
          {
            label: '新增应付金额',
            value: convertNumber(data.newAddAmount || 0),
            unit: '元',
            tooltip: '统计周期内应付金额总和',
            // 财务-应付管理 应付时间为统计周期时间
            clickCallback: () => {
              this.toFinancePayableList({})
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.newAddDayRadio,
                },
                {
                  name: '周同比',
                  value: data.newAddWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '押金退款',
            value: convertNumber(data.depositRefundAmount || 0),
            unit: '元',
            tooltip: '统计周期内付款内容为“押金退款”的应付金额总和',
            // 财务-应付管理 付款内容为“押金退款”
            clickCallback: () => {
              this.toFinancePayableList({ payType: 12 })
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.depositRefundDayRadio,
                },
                {
                  name: '周同比',
                  value: data.depositRefundWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '应退租金',
            value: convertNumber(data.rentAmount || 0),
            unit: '元',
            tooltip: '统计周期内付款内容为“租金”的应付金额总和',
            // 财务-应付管理 付款内容为“租金”
            clickCallback: () => {
              this.toFinancePayableList({ payType: 1 })
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.rentDayRadio,
                },
                {
                  name: '周同比',
                  value: data.rentWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '付款完成率',
            value: ((data.paymentFinishRadio || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内付款单已付金额总和/应付金额总和',
            // 财务-应付管理
            clickCallback: () => {
              this.toFinancePayableList({})
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.paymentFinishDayRadio,
                },
                {
                  name: '周同比',
                  value: data.paymentFinishWeekRadio,
                },
              ]
              : [],
          },
          // 占位
          {},
        ]
      }
    },
    // 获取车辆成本&营销成本
    async getFinanceCost() {
      const res = await getFinanceCost(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.vehicleData.primaryDataList = [
          {
            label: '车辆购买成本',
            value: convertNumber(data.buyCarAmount || 0),
            unit: '元',
            tooltip: '统计周期内付款内容为“租金”，采购方式为“购买”的应付金额总和。',
            // 财务-应付管理 付款内容为“租金” 采购方式“购买”
            clickCallback: () => this.toFinancePayableList({
              payType: 1,
              purchaseType: 1,
            }),
          },
          {
            label: '车辆租用成本',
            value: convertNumber(data.rentCarAmount || 0),
            unit: '元',
            tooltip: '统计周期内付款内容为“租金”，采购方式为“转租”的应付金额总和。',
            // 财务-应付管理 付款内容为“租金” 采购方式“租用”
            clickCallback: () => this.toFinancePayableList({
              payType: 1,
              purchaseType: 2,
            }),
          },
        ]
        this.marketingData.primaryDataList = [
          {
            label: '金额减免',
            value: convertNumber(data.reducedAmount || 0),
            unit: '元',
            tooltip: '统计周期内应收单中“减免金额”总和。',
            // 财务-应收管理 减免金额“是”
            clickCallback: () => {
              this.toFinanceCollectionList({ relieveState: 1 })
            },
          },
        ]
      }
    },
    // 获取欠款
    async getFinanceDebt() {
      const res = await getFinanceDebt(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.debtData.primaryDataList = [
          {
            label: '欠款总额',
            value: convertNumber((data.totalAmount || 0) / 10000),
            unit: '万元',
            valueTooltip: `${convertNumber(data.totalAmount || 0)}元`,
            tooltip: '应收日期在统计周期内收款状态为“未完成”的剩余应收总和',
            width: '266px',
            // 财务-应收管理，收款状态“未完成”，应收时间“统计周期”
            clickCallback: () => {
              this.toFinanceCollectionList({ receivableStates: 0 })
            },
          },
        ]
        this.debtData.secondaryDataList = [
          {
            label: '个人客户欠款',
            value: convertNumber(data.individualAmount || 0),
            unit: '元',
            tooltip: '应收日期在统计周期内收款状态为“未完成”付款方类型为“个人客户”的剩余应收总和。',
            // 财务-应收管理，收款状态“未完成”，应收时间“统计周期”，付款方类型“个人客户”
            clickCallback: () => {
              this.toFinanceCollectionList({
                receivableStates: 0,
                customerType: 2,
                customerInfoType: 1, // 客户类型为个人客户
              })
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.individualDayRadio,
                },
                {
                  name: '周同比',
                  value: data.individualWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '企业客户欠款',
            value: convertNumber(data.enterpriseAmount || 0),
            unit: '元',
            tooltip: '应收日期在统计周期内收款状态为“未完成”付款方类型为“企业客户”的剩余应收总和。',
            // 财务-应收管理，收款状态“未完成”，应收时间“统计周期”，付款方类型“企业客户”
            clickCallback: () => {
              this.toFinanceCollectionList({
                receivableStates: 0,
                customerType: 2,
                customerInfoType: 2, // 客户类型为企业客户
              })
            },
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.enterpriseDayRadio,
                },
                {
                  name: '周同比',
                  value: data.enterpriseWeekRadio,
                },
              ]
              : [],
          },
          {
            label: '欠款率',
            value: ((data.debtRadio || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '统计周期内应收单中剩余应收金额总和/应收金额总和',
            // 财务-应收管理，收款状态“未完成”，应收时间“统计周期”
            clickCallback: () => {
              this.toFinanceCollectionList({ receivableStates: 0 })
            },
          },
          // 占位
          {},
          {},
        ]
      }
    },
    // 获取收款金额图表
    async getFinanceReceivableChart() {
      const res = await getFinanceReceivableChart(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.receivableChartData.xAxis.data = data.map((item) => item.statDate) || []
        this.receivableChartData.seriesData = [
          {
            name: '应收金额',
            data: data.map((item) => ([
              item.statDate,
              ((item.receivableAmount || 0) / 10000).toFixed(2),
              {
                dataTitle: this.receivableChartData.title,
              },
            ])),
          }, {
            name: '实收金额',
            data: data.map((item) => ([
              item.statDate,
              ((item.receivedAmount || 0) / 10000).toFixed(2),
              {
                dataTitle: this.receivableChartData.title,
              },
            ])),
          },
        ]
      }
    },
    // 获取付款金额图表
    async getFinancePaymentChart() {
      const res = await getFinancePaymentChart(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.paymentChartData.xAxis.data = data.map((item) => item.statDate) || []
        this.paymentChartData.seriesData = [
          {
            name: '应付金额',
            data: data.map((item) => ([
              item.statDate,
              ((item.paymentAmount || 0) / 10000).toFixed(2),
              {
                dataTitle: this.paymentChartData.title,
              },
            ])),
          },
          {
            name: '已付金额',
            data: data.map((item) => ([
              item.statDate,
              ((item.paidAmount || 0) / 10000).toFixed(2),
              {
                dataTitle: this.paymentChartData.title,
              },
            ])),
          },
        ]
      }
    },
    // 获取欠款金额图表
    async getFinanceDebtChart() {
      const res = await getFinanceDebtChart(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.debtChartData.xAxis.data = data.map((item) => item.statDate) || []
        this.debtChartData.seriesData = [
          {
            name: '个人客户',
            data: data.map((item) => ([
              item.statDate,
              ((item.individualAmount || 0) / 10000).toFixed(2),
              {
                dataTitle: this.debtChartData.title,
              },
            ])),
          },
          {
            name: '企业客户',
            data: data.map((item) => ([
              item.statDate,
              ((item.enterpriseAmount || 0) / 10000).toFixed(2),
              {
                dataTitle: this.debtChartData.title,
              },
            ])),
          },
        ]
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
